import { EventEmitter, Injectable } from '@angular/core';
import type { ErrorDto } from '../models/error-dto';
import type { ErrorResponseDto } from '../models/error-response-dto';

@Injectable({
  providedIn: 'root'
})
export class CommonMessageTransferService {

  private restAPIFieldErrorEventVar = new EventEmitter<ErrorResponseDto>();
  private restAPIGeneralErrorEventMethod = new EventEmitter<ErrorDto>();

  constructor() { }

  get restAPIGeneralErrorEvent(): EventEmitter<ErrorDto> {
    return this.restAPIGeneralErrorEventMethod;
  }
  get restAPIFieldErrorEvent(): EventEmitter<ErrorResponseDto> {
    return this.restAPIFieldErrorEventVar;
  }
  throwFieldsError(errors: ErrorResponseDto) {
    this.restAPIFieldErrorEventVar.emit(errors);
  }

  throwGeneralError(error: ErrorDto) {
    this.restAPIGeneralErrorEventMethod.emit(error);
  }
}
